import TabPanels from './tab-panels.vue';

export default TabPanels;



// WEBPACK FOOTER //
// ./src/components/tab-panels/index.js